export default function getLocalization(stringKey) {
  if (typeof window.varassaari_screenReaderText === 'undefined' || typeof window.varassaari_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.varassaari_screenReaderText[stringKey];
}
